module.exports = __webpack_public_path__ + "img/logo-hammer-strength.d38072b.svg";